import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', size = 'md', className = '' }) => {
  const variantStyles = {
    default: 'bg-neutral-100 text-neutral-700 ring-1 ring-inset ring-neutral-200',
    success: 'bg-success-50 text-success-600 ring-1 ring-inset ring-success-500/20',
    warning: 'bg-warning-50 text-warning-600 ring-1 ring-inset ring-warning-500/20',
    error: 'bg-error-50 text-error-600 ring-1 ring-inset ring-error-500/20',
    info: 'bg-primary-50 text-primary-600 ring-1 ring-inset ring-primary-500/20',
  };

  const sizeStyles = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span className={`inline-flex items-center rounded-lg font-semibold tracking-wide uppercase ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}>
      {children}
    </span>
  );
};
